jQuery(document).ready(function () {
    jQuery('.header__hamburger').on('click', function () {
        jQuery("#mobile-menu-wrapper").toggleClass("active");
        jQuery(".header__hamburger-wrapper").toggleClass("active");
        jQuery('html').toggleClass("no-overflow");
        jQuery('body').toggleClass("no-overflow");
        jQuery('.header__wrapper').toggleClass('active');
    });
    jQuery('.mobile__accordion-icon-wrapper').on('click', function (e) {
        e.preventDefault();
        jQuery(this).closest('li').toggleClass("open");
    });


});